import { DOCUMENT_TYPE, PROFIL } from '../../../constants/enum';
import { DropzoneArea, DropzoneAreaBase } from 'material-ui-dropzone';
import MyButton from '../../Layout/MyButton';
import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons';
import DocumentViewer from '../DocumentViewer';
import React, { useEffect } from 'react';

const StepDocuments = (props) => {
  const {
    refs,
    profil,
    onDropZoneAreaChange,
    notAbleToChange,
    renderDropZonePreview,
    validSteps,
    onNextStep,
    demandePassage,
    caracConvoi,
    setDocuments,
    documents,
    setAdminDocuments,
    adminDocuments,
    viewerIsOpen,
    setViewerIsOpen,
    viewerFile,
  } = props;

  const editable = notAbleToChange || !(profil.profil === PROFIL.ADMINISTRATEUR || profil.profil === PROFIL.GESTIONNAIRE || profil.profil === PROFIL.CLIENT);

  return (
    <div ref={(divRef) => refs.current['step-documents'] = divRef} className='step'>
      <div className='step-content'>
        {(profil.profil !== PROFIL.INTERVENANT || profil.profil !== PROFIL.CONSULTANT) && <>
          <div className='step-content-row'>
            <h3 className='modal-step-title'>Import des documents</h3>

            <div>
              <ol>
                <li>Document Cerfa</li>
                <li>Reconnaissance de l'itinéraire - pour les PA</li>
                {/* TODO: Si la nature du chargement déclarée dans l'onglet "Caractéristiques du convoi" est "Grue"*/}
                {caracConvoi.natureCharge === 'Grue' && <li>Fiche Grue</li>}
              </ol>
            </div>
            <div style={{
              fontSize: '24px',
              fontWeight: 'bold',
              marginLeft: '30px',
            }}>Documents externes :
            </div>
            <div style={{display: 'flex', marginLeft: '30px'}} className={'passage-document'}>
              {/* WORKAROUND: le composant DropZoneArea ne se met pas à jour de lui-même lors du la maj de initialFiles */}
              {documents.initialFiles &&
                <DropzoneAreaBase //masked for readonly because of the trash icon
                  dropzoneClass={'drop-zone-container'}
                  onAdd={(files) => onDropZoneAreaChange(files, DOCUMENT_TYPE.DOCUMENT)}
                  onDelete={(file) => onDropZoneAreaChange(file, DOCUMENT_TYPE.DOCUMENT)}
                  acceptedFiles={['image/jpeg', 'image/png', 'application/pdf', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']}
                  initialFiles={documents.initialFiles}
                  dropzoneParagraphClass={'dropzone-paragraph'}
                  dropzoneText={'Insérer ici les documents'}
                  maxFileSize={50000000}
                  showPreviews={true}
                  showPreviewsInDropzone={false}
                  getPreviewIcon={renderDropZonePreview}
                  dropzoneProps={{ disabled: false }}
                  filesLimit={20}
                  previewText={'Aperçu:'}
                  showAlerts={false}
                  fileObjects={documents.files}
                />}
              {!documents.initialFiles &&
                <DropzoneAreaBase
                  dropzoneClass={'drop-zone-container'}
                  dropzoneParagraphClass={'dropzone-paragraph'}
                  dropzoneText={'Insérer ici les documents'}
                  onAdd={(files) => onDropZoneAreaChange(files, DOCUMENT_TYPE.DOCUMENT)}
                  onDelete={(files) => onDropZoneAreaChange(files, DOCUMENT_TYPE.DOCUMENT)}
                  acceptedFiles={['image/jpeg', 'image/png', 'application/pdf', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']}
                  maxFileSize={50000000}
                  showPreviews={true}
                  showPreviewsInDropzone={true}
                  getPreviewIcon={renderDropZonePreview}
                  dropzoneProps={{ disabled: editable }}
                  filesLimit={20}
                  previewText={'Aperçu:'}
                  showAlerts={false}
                  fileObjects={documents.files}
                />}
            </div>

            {/* WORKAROUND: le composant DropZoneArea ne se met pas à jour de lui-même lors du la maj de initialFiles */}
            {(profil.profil === PROFIL.ADMINISTRATEUR || profil.profil === PROFIL.GESTIONNAIRE || profil.profil === PROFIL.INTERVENANT) &&
              <>
                <div style={{
                  fontSize: '24px',
                  fontWeight: 'bold',
                  marginLeft: '30px',
                }}>Documents internes : </div>
                <div style={{display: 'flex', marginLeft: '30px'}} className={'passage-document'}>
                  {adminDocuments.initialFiles &&
                    <DropzoneAreaBase //masked for readonly because of the trash icon
                      onAdd={(files) => onDropZoneAreaChange(files, DOCUMENT_TYPE.DOCUMENT_ADMIN)}
                      onDelete={(file) => onDropZoneAreaChange(file, DOCUMENT_TYPE.DOCUMENT_ADMIN)}
                      acceptedFiles={['image/jpeg', 'image/png', 'application/pdf', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']}
                      initialFiles={adminDocuments.initialFiles}
                      dropzoneClass={'drop-zone-container'}
                      dropzoneParagraphClass={'dropzone-paragraph'}
                      dropzoneText={'Insérer ici les documents'}
                      maxFileSize={50000000}
                      showPreviews={true}
                      showPreviewsInDropzone={false}
                      getPreviewIcon={renderDropZonePreview}
                      filesLimit={20}
                      previewText={'Aperçu:'}
                      showAlerts={false}
                      fileObjects={adminDocuments.files}
                    />}
                  {!adminDocuments.initialFiles &&
                    <DropzoneAreaBase
                      dropzoneClass={'drop-zone-container'}
                      dropzoneParagraphClass={'dropzone-paragraph'}
                      dropzoneText={'Insérer ici les documents'}
                      onAdd={(files) => onDropZoneAreaChange(files, DOCUMENT_TYPE.DOCUMENT_ADMIN)}
                      onDelete={(files) => onDropZoneAreaChange(files, DOCUMENT_TYPE.DOCUMENT_ADMIN)}
                      acceptedFiles={['image/jpeg', 'image/png', 'application/pdf', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']}
                      maxFileSize={50000000}
                      showPreviews={true}
                      showPreviewsInDropzone={true}
                      getPreviewIcon={renderDropZonePreview}
                      filesLimit={20}
                      previewText={'Aperçu:'}
                      showAlerts={false}
                      fileObjects={adminDocuments.files}
                    />}
                </div>
              </>
            }
          </div>

          {(profil.profil === PROFIL.ADMINISTRATEUR || profil.profil === PROFIL.GESTIONNAIRE) && demandePassage.id !== 0 &&
            <div className='row' style={{ justifyContent: 'flex-end', alignItems: 'center', height: '80px' }}>
              <MyButton
                style={validSteps['step6'] ? 'buttonRejected' : 'buttonValidation'}
                label={validSteps['step6'] ? 'Rejeter l\'étape' : 'Valider l\'étape'}
                icon={validSteps['step6'] ? faXmark : faCheck}
                onClick={() => {
                  onNextStep(setDocuments, documents, 6);
                  onNextStep(setAdminDocuments, adminDocuments, 6);
                }}
              />
            </div>}
        </>}
      </div>
      {viewerIsOpen &&
        <DocumentViewer
          setIsOpen={setViewerIsOpen}
          isOpen={viewerIsOpen}
          file={viewerFile}
        />}
    </div>);
};

export default StepDocuments;